import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {},
  header: {
    display: 'flex',
  },
  title: {
    flex: 1,
  },
  action: {},
  content: {},
}))
